var _defs, _path, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,.2C9.07.2.2,9.06.2,20s8.87,19.8,19.8,19.8,19.8-8.87,19.8-19.8S30.94.2,20,.2ZM31.58,20.14c0,1.24-.2,4.49-.35,5.09-.44,1.75-1.27,2.44-2.8,2.68-.87.13-5.08.3-8.43.3h0-.02,0c-3.35,0-7.56-.17-8.44-.3-1.52-.25-2.35-.93-2.79-2.68-.15-.6-.35-3.85-.35-5.09v-.27c0-1.24.2-4.49.35-5.08.44-1.76,1.27-2.44,2.79-2.69.88-.13,5.09-.3,8.44-.3h0,.02,0c3.35,0,7.56.17,8.43.3,1.53.24,2.36.92,2.8,2.69.15.59.35,3.84.35,5.08v.27Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17.59 23.25 23.75 19.88 17.59 16.68 17.59 23.25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeNew);
export default __webpack_public_path__ + "static/media/youtube_new.0d911d3ac595449336f512bcb6028f0a.svg";
export { ForwardRef as ReactComponent };